import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { signIn } from "next-auth/react";
import { AuthLoginDto, authLoginSchema } from "@/Dtos/auth-dto";
import routes from "@/routers/routes";
import useAuthStore from "@/store/AuthStore";
import { Form } from "@/ui/form";
import { IsNullOrWhiteSpace } from "@/utils/Utils";
import { SubmitHandler } from "react-hook-form";
import { PiArrowRightBold } from "react-icons/pi";
import { Button, Input, Password } from "rizzui";

export default function SignInForm() {
    //TODO: why we need to reset it here
    const [reset, setReset] = useState({});

    const navigate = useNavigate();

    const { isLoading, login, Error, auth, isAuthorized } = useAuthStore(
        (s) => s,
    );

    const onSubmit: SubmitHandler<AuthLoginDto> = async (data) => {
        console.log(data);
        await login(data);

        if (
            !isLoading &&
            IsNullOrWhiteSpace(Error?.message) &&
            Error?.errors === null
        ) {
            setReset({ email: "", password: "" });
        }
        // else if (!IsNullOrWhiteSpace(Error?.message)) {
        //     toast.error(Error?.message ?? "An error occurred");
        // }
    };

    useEffect(() => {
        if (isAuthorized && auth !== undefined) {
            if (isAuthorized) navigate(routes.dashboards.index);
        }
    }, [isAuthorized, auth]);

    return (
        <Form<AuthLoginDto>
            validationSchema={authLoginSchema}
            resetValues={reset}
            onSubmit={onSubmit}
            useFormProps={{
                mode: "onChange",
                defaultValues: {
                    username: "",
                    password: "",
                },
            }}
        >
            {({ register, formState: { errors } }) => (
                <div className="space-y-5">
                    <Input
                        type="text"
                        size="lg"
                        label="Username"
                        placeholder="Enter your username"
                        className="[&>label>span]:font-medium"
                        inputClassName="text-sm"
                        {...register("username")}
                        error={errors.username?.message}
                    />
                    <Password
                        label="Password"
                        placeholder="Enter your password"
                        size="lg"
                        className="[&>label>span]:font-medium"
                        inputClassName="text-sm"
                        {...register("password")}
                        error={errors.password?.message}
                    />
                    <div className="flex items-center justify-end pb-2">
                        {/* <Link
                            to={routes.auth.forgotPassword}
                            className="h-auto p-0 text-sm font-semibold text-blue underline transition-colors hover:text-gray-900 hover:no-underline"
                        >
                            Forget Password?
                        </Link> */}
                    </div>
                    <Button
                        className="w-full"
                        type="submit"
                        size="lg"
                        isLoading={isLoading}
                    >
                        <span>Sign in</span>{" "}
                        <PiArrowRightBold className="ms-2 mt-0.5 h-6 w-6" />
                    </Button>
                </div>
            )}
        </Form>
    );
}
